import * as React from 'react';

import IEncoderQueryParams from './IEncoderQueryParams';

import ManualEncoder from './ManualEncoder';
import AutomaticEncoder from './AutomaticEncoder';

import * as Sentry from '@sentry/browser';

interface State {
}

interface Props {
    queryParams: IEncoderQueryParams;
}

/* EncoderApp is the root component in the Encoder. */
export default class EncoderApp extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    
    Sentry.configureScope((scope: Sentry.Scope) => {
      scope.setExtra("wideoId", this.props.queryParams.wideoId);
    });
  }

  render() {

    return (
        <div>
          { this.props.queryParams.serverName &&
            <AutomaticEncoder {...this.props} />
          }
          { !this.props.queryParams.serverName &&
            <ManualEncoder {...this.props} />
          }
        </div>
    );
  }
}
